<template>
    <div id="contact-wrapper">
        <div id="contact">
            <h2>联 系 我 们<span class="line"></span></h2>
            <div class="contact">
                <div class="contact-map">
                    <img src="@/assets/image/index/contactUs.png" />
                </div>
                <div class="contact-detail">
                    <img src="@/assets/image/index/contactUs2.jpeg" />
                    <ul>
                        <li><strong>邮编：</strong>100010</li>
                        <li><strong>地址：</strong>北京市东城区夕照寺中街31楼8层2座0823-210</li>
                        <li><strong>邮箱：</strong>gxjy@gxjydata.com</li>
                        <li><strong>电话：</strong>13717615054 / 18888888888 / 18888888887</li>
                        <li><strong>传真：</strong>0755-88886666</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
#contact-wrapper{
    width:100%;
    background:#fff;
}
#contact{
    width: 1280px;
    margin:0 auto;
    text-align:center;
    padding-top:24px;
}
#contact h2 {
    color: #116EBA;
    font-family: 思源黑体 CN;
    font-size: 20px;
    padding-bottom:10px;
    position:relative;
    margin-bottom: 40px;
}
.line{
    display:block;
    width: 72px;
    height: 3px;
    background: #116EBA;
    position:absolute;
    bottom: 0;
    left:50%;
    transform: translate(-50%);
}
.contact{
    overflow:hidden;
    padding-bottom: 45px;
}
.contact-map img{
    display:block;
    width: 540px;
    height: 291px;
    float:left;
}
.contact-detail{
    float:left;
    margin-left:80px;
}
.contact-detail img {
    display: block;
    width: 358px;
    height: 113px;
    margin-bottom: 20px;
}
.contact-detail ul {
    text-align:left;
    padding-left: 20px;
}
.contact-detail ul li {
    font-family: 思源黑体 CN;
    font-size: 16px;
    margin-bottom:10px;
}
</style>